import React from 'react';

import './Button.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import Tooltip from '../Tooltip/Tooltip'
import Refresh from '@material-ui/icons/Refresh'
import Edit from '@material-ui/icons/Edit'
import Visibility from '@material-ui/icons/Visibility'

        const button = (props) => {
    let iconClass = ''
    let textClass = "BtnText"
    let containerClass = "BtnCntntCntnr"
    if (props.btnType === 'Success') {
        // iconClass = "BtnIcon"
    } else if (props.btnType === 'Back') {
        iconClass = "BtnIconBack"
        textClass = "BtnTextBack"
        containerClass = ''
    }
    let icon = ''
    if (props.btnType === 'Success') {
        // icon = faCheck
    } else if (props.btnType === 'Back') {
        icon = faArrowRight
    }
    const btn = <button
        disabled={props.disabled}
        className={["Button", props.btnType, props.className].join(' ')}
        onClick={props.clicked}
        >
        <div className={containerClass}>
            <div className={iconClass}><FontAwesomeIcon icon={icon} /></div>
            {props.btnType != 'Back' ? <div className={textClass}>{props.children}</div> : ''}
        </div>
    </button>
    let container = ''
    if (props.btnType == 'Edit') {
        container = <div className="Edit" onClick={props.clicked}><Edit className="BtnIcon" /></div>
    } else if (props.btnType == 'State') {

        container = <button onClick={props.clicked} className={["Button", props.btnType, props.className].join(' ')}>{props.children}</button>

    } else if (props.btnType == 'Refresh') {

        container = <div className="Edit" onClick={props.clicked}><Refresh className="RefreshIcon" /></div>

    } else if (props.btnType == 'View') {

        container = <div className="Edit" onClick={props.clicked}><Visibility className="RefreshIcon" /></div>

    } else {
        container = btn
    }
    if (props.btnType == 'Refresh') {

        container = <div className="refresh-btn" onClick={props.clicked}><Refresh className="RefreshIcon" /></div>

    }




    return (
            container
            )
}


export default button;